export default __webpack_public_path__ + "static/og-default-995d00fd4896dc41803ef36a660d32e6.jpg";